module.exports = __webpack_public_path__ + "img/delete.627b09d1.svg";